import dayjs from "dayjs";
import { Dispatch, SetStateAction } from "react";

export const updateSelectedFilterItemsName = (
  filterState: Record<string, any>,
  selectedItems: Record<string, any>,
  setSelectedFilterItems: Dispatch<SetStateAction<string>>,
  filterStateValues: string[],
  displayFormats: Record<string, string> = {},
) => {
  const selectedValues = filterStateValues
    .map((item) => {
      if (selectedItems[item]) {
        if (dayjs.isDayjs(filterState[item])) {
          const format = displayFormats[item] || "YYYY-MM-DD";
          return filterState[item]?.format(format);
        }
        return filterState[item]?.name || filterState[item] || "";
      }
      return "";
    })
    .filter(Boolean);
  const selectedItemsString = selectedValues.join(", ");
  setSelectedFilterItems(selectedItemsString);
};
